(() => {
  const sourceSelector = '[data-juniper-benefits-source]';
  const focusableSelector =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function mount(source) {
    if (!source || source.dataset.juniperBenefitsMounted === 'true') return true;

    const sectionRoot = source.closest('.shopify-section') || document;
    const formButtons =
      sectionRoot.querySelector('.product-form-buttons.sunfade-purchase-stack') ||
      sectionRoot.querySelector('.product-form-buttons');
    const quantityLine = formButtons?.querySelector('.sunfade-quantity-line');
    const benefitList = source.querySelector('[data-juniper-benefits-list]');
    const layer = source.querySelector('[data-juniper-benefit-layer]');
    const drawer = layer?.querySelector('[data-juniper-benefit-drawer]');

    if (!formButtons || !quantityLine || !benefitList || !layer || !drawer) return false;

    source.dataset.juniperBenefitsMounted = 'true';

    const existingDrawer = document.getElementById(drawer.id);
    if (existingDrawer && existingDrawer !== drawer) {
      existingDrawer.closest('[data-juniper-benefit-layer]')?.remove();
    }

    formButtons.insertBefore(benefitList, quantityLine.nextSibling);
    document.body.append(layer);
    source.remove();

    const heading = layer.querySelector('[data-juniper-benefit-heading]');
    const panels = [...layer.querySelectorAll('[data-juniper-benefit-panel]')];
    const openButtons = [...benefitList.querySelectorAll('[data-juniper-benefit-open]')];
    const closeButtons = [...layer.querySelectorAll('[data-juniper-benefit-close]')];
    let lastFocused = null;
    let activeButton = null;
    let closeTimer = null;

    const finishClose = () => {
      if (!layer.classList.contains('is-open')) layer.hidden = true;
    };

    const closeDrawer = () => {
      if (layer.hidden) return;

      window.clearTimeout(closeTimer);
      layer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('juniper-benefit-drawer-open');
      openButtons.forEach((button) => button.setAttribute('aria-expanded', 'false'));
      activeButton = null;
      closeTimer = window.setTimeout(finishClose, 320);

      if (lastFocused?.isConnected) lastFocused.focus();
    };

    const openDrawer = (key, trigger) => {
      const activePanel = panels.find((panel) => panel.dataset.juniperBenefitPanel === key);
      if (!activePanel) return;

      window.clearTimeout(closeTimer);
      panels.forEach((panel) => {
        panel.hidden = panel !== activePanel;
      });
      openButtons.forEach((button) => {
        button.setAttribute('aria-expanded', String(button === trigger));
      });

      heading.textContent = trigger.dataset.juniperBenefitTitle || activePanel.querySelector('h3')?.textContent || '';
      lastFocused = trigger;
      activeButton = trigger;
      layer.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      drawer.scrollTop = 0;
      document.documentElement.classList.add('juniper-benefit-drawer-open');

      requestAnimationFrame(() => {
        layer.classList.add('is-open');
        layer.querySelector('.juniper-benefit-drawer__close')?.focus();
      });
    };

    openButtons.forEach((button) => {
      button.addEventListener('click', () => openDrawer(button.dataset.juniperBenefitOpen, button));
    });

    closeButtons.forEach((button) => button.addEventListener('click', closeDrawer));

    layer.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeDrawer();
        return;
      }

      if (event.key !== 'Tab' || layer.hidden) return;

      const focusable = [...drawer.querySelectorAll(focusableSelector)].filter(
        (element) => !element.hidden && element.getClientRects().length > 0,
      );
      if (!focusable.length) {
        event.preventDefault();
        drawer.focus();
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    layer.addEventListener('transitionend', (event) => {
      if (event.target === drawer && !layer.classList.contains('is-open')) finishClose();
    });

    document.addEventListener('shopify:section:unload', (event) => {
      if (event.detail?.sectionId !== source.dataset.sectionId) return;
      if (activeButton) closeDrawer();
      layer.remove();
    });

    return true;
  }

  function init(root = document) {
    const sources = [];
    if (root.matches?.(sourceSelector)) sources.push(root);
    sources.push(...root.querySelectorAll?.(sourceSelector) || []);
    sources.forEach(mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  const observer = new MutationObserver(() => init());
  observer.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  window.addEventListener('pageshow', () => init());
})();

